import './commit-detail-panel-sk';
